import React, { Component } from 'react';
import * as AppointmentReducer from '../../../../actions/Appointment.js';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

export class NavigationArrow extends Component {
    _reload = () => {
        if(this.props.direction === "forward") {
            this.props.schedule.Load(this.props.offset + 1, this.props.id, this.props.gender);
        } else {
            this.props.schedule.Load(this.props.offset - 1, this.props.id, this.props.gender);
        }
    }

    render() {
        return(
            <div className="content__navigation-arrow" onClick={this._reload}>
                {this.props.text}
            </div>
        );

    }
}

const mapStateToProps = state => ({
    id: state.AppointmentReducer.id,
    gender: state.AppointmentReducer.gender,
});

function mapDispatchToProps(dispatch) {
    return {
        schedule: bindActionCreators(AppointmentReducer, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavigationArrow);


// WEBPACK FOOTER //
// frontend/src/modules/appointment-table/nav/arrow/index.jsx